import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import { RestCustomServerChange } from 'src/components/AppUpdate/RestCustomServerChange'
import { appVersion, lastBuildDate } from 'src/consumer/services'
import {
  AboutContainer,
  AboutContent,
  AboutTitle,
  VersionCard,
  VersionInfoRow,
  VersionIcon,
  VersionTextContainer,
  VersionLabel,
  VersionValue,
  ReleaseDateValue,
  Divider,
  DeveloperToolsContainer,
} from './AboutStyle'

const About = (props) => {
  const { localizedContent } = props
  const [tapCount, setTapCount] = useState(0)

  return (
    <>
      <AboutContainer>
        <AboutContent>
          <AboutTitle>{localizedContent?.about || 'About'}</AboutTitle>
          
          <VersionCard onClick={() => setTapCount((prev) => prev + 1)}>
            <VersionInfoRow>
              <VersionIcon>
                <InfoOutlinedIcon style={{ fontSize: '24px' }} />
              </VersionIcon>
              <VersionTextContainer>
                <VersionLabel>
                  {localizedContent?.app_version || 'App Version'}
                </VersionLabel>
                <VersionValue>{appVersion}</VersionValue>
              </VersionTextContainer>
            </VersionInfoRow>
            
            <Divider />
            
            <VersionInfoRow last>
              <VersionIcon>
                <CalendarTodayOutlinedIcon style={{ fontSize: '24px' }} />
              </VersionIcon>
              <VersionTextContainer>
                <VersionLabel>
                  {localizedContent?.release_date || 'Release Date'}
                </VersionLabel>
                <ReleaseDateValue>{lastBuildDate}</ReleaseDateValue>
              </VersionTextContainer>
            </VersionInfoRow>
          </VersionCard>
          
          {tapCount > 10 && (
            <DeveloperToolsContainer>
              <RestCustomServerChange />
            </DeveloperToolsContainer>
          )}
        </AboutContent>
      </AboutContainer>
    </>
  )
}

export default About
